/* KLIK v2 cart store (package bugs-cart, PF-17 / K-113).
   window.KlikCart.get({fresh}) returns one shared /cart.js promise for 2 s; a cart mutation or `cart:updated` refreshes it.
   GET /cart.js calls made through fetch by other scripts share the same promise (same JSON, a new Response for each caller),
   so a page makes one cart read where it made six. Mutations (add, change, update, clear) are never touched; they only
   invalidate the shared read. Loaded with defer from snippets/cart-drawer.liquid. */
(function (win) {
  'use strict';
  if (!win || win.KlikCart) return;
  var doc = win.document, TTL = 2000;
  var nativeFetch = win.fetch && win.fetch.bind(win);
  var shared = null, startedAt = 0, sharedCookie = null, last = null, generation = 0;
  // The shared read belongs to one cart: a changed `cart` cookie (EN↔AR handoff, a new cart) always reads again.
  function cartCookie() {
    try { var m = doc.cookie.match(/(?:^|;\s*)cart=([^;]*)/); return m ? m[1] : ''; } catch (_) { return ''; }
  }

  function root() { return ((win.Shopify && win.Shopify.routes && win.Shopify.routes.root) || '/').replace(/\/?$/, '/'); }
  function urlOf(input) {
    try { return new URL(typeof input === 'string' ? input : (input && input.url) || '', win.location.href); } catch (_) { return null; }
  }
  // Plain reads only: /cart.js with no query, or with Motion's cache-buster `t`.
  function isCartRead(url, method) {
    if (!url || url.origin !== win.location.origin || (method && method.toUpperCase() !== 'GET')) return false;
    if (!/\/cart\.js$/.test(url.pathname)) return false;
    var plain = true;
    url.searchParams.forEach(function (_, key) { if (key !== 't') plain = false; });
    return plain;
  }
  function isCartWrite(url) {
    return !!url && url.origin === win.location.origin && /\/cart\/(add|change|update|clear)(\.js|\.json)?$/.test(url.pathname);
  }
  function invalidate() { shared = null; startedAt = 0; generation += 1; }

  function read() {
    if (!nativeFetch) return Promise.reject(new Error('fetch unavailable'));
    var mine = generation;
    var request = nativeFetch(root() + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error('Cart unavailable (' + response.status + ')'); return response.json(); })
      .then(function (cart) { if (mine === generation) { last = cart; paintCount(cart); } return cart; });
    request.catch(function () { if (shared === request) invalidate(); });
    return request;
  }

  function get(options) {
    var fresh = options && options.fresh, cookie = cartCookie();
    if (!fresh && shared && Date.now() - startedAt < TTL && cookie === sharedCookie) return shared;
    shared = read(); startedAt = Date.now(); sharedCookie = cookie;
    return shared;
  }

  // The grouping key of a line: one set = one entry in the bag count.
  function groupKey(item) {
    var p = (item && item.properties) || {};
    var key = p._KLIK_room_set || p._KLIK_set_id || ''; // buy-fix: one studio add (sofa pieces + tables) counts once
    if (!key && typeof p._klik_configuration === 'string' && /^KLIK-[A-Za-z0-9-]{4,60}$/.test(p._klik_configuration)) key = p._klik_configuration;
    return key ? String(key) : '';
  }
  function count(cart) {
    var items = (cart && cart.items) || [], sizes = {}, seen = {}, total = 0;
    items.forEach(function (item) { var k = groupKey(item); if (k) sizes[k] = (sizes[k] || 0) + 1; });
    items.forEach(function (item) {
      var k = groupKey(item);
      if (k && sizes[k] > 1) { if (!seen[k]) { seen[k] = true; total += 1; } }
      else total += Number(item.quantity) || 0;
    });
    return total;
  }
  function paintCount(cart) {
    if (!cart) return;
    var n = count(cart);
    doc.querySelectorAll('[data-kt-cart-count], .cart-link__bubble-num').forEach(function (node) {
      if (node.textContent !== String(n)) node.textContent = String(n);
    });
    doc.querySelectorAll('.cart-link__bubble').forEach(function (bubble) { bubble.classList.toggle('cart-link__bubble--visible', n > 0); });
    doc.documentElement.classList.toggle('kcv-has-cart', n > 0);
  }

  // Share plain /cart.js reads made with fetch by other scripts (DPO safety, display adapters, express checkout…).
  if (nativeFetch) {
    win.fetch = function (input, init) {
      var method = (init && init.method) || (input && typeof input === 'object' && input.method) || 'GET';
      var url = urlOf(input);
      if (isCartRead(url, method) && !(init && init.signal && init.signal.aborted)) {
        return get().then(function (cart) {
          return new Response(JSON.stringify(cart), { status: 200, headers: { 'Content-Type': 'application/json; charset=utf-8' } });
        });
      }
      if (isCartWrite(url)) {
        invalidate();
        return nativeFetch(input, init).then(function (response) { invalidate(); return response; }, function (error) { invalidate(); throw error; });
      }
      return nativeFetch(input, init);
    };
  }
  // jQuery / DPO writes go through XMLHttpRequest: they only invalidate the shared read.
  if (win.XMLHttpRequest && win.XMLHttpRequest.prototype) {
    var open = win.XMLHttpRequest.prototype.open;
    win.XMLHttpRequest.prototype.open = function (method, url) {
      // DPO reads the cart with a plain GET /cart/update.json: only a non-GET call or one with parameters can change the cart.
      try { var u = urlOf(url); if (isCartWrite(u) && (String(method).toUpperCase() !== 'GET' || u.search)) { invalidate(); this.addEventListener('loadend', invalidate); } } catch (_) {}
      return open.apply(this, arguments);
    };
  }

  doc.addEventListener('cart:updated', function (event) {
    var cart = event && event.detail && event.detail.cart;
    if (cart && Array.isArray(cart.items)) { last = cart; shared = Promise.resolve(cart); startedAt = Date.now(); sharedCookie = cartCookie(); paintCount(cart); }
    else invalidate();
  });
  ['ajaxProduct:added', 'klik:cart-added', 'cart:build'].forEach(function (name) { doc.addEventListener(name, invalidate); });

  win.KlikCart = Object.freeze({
    get: get,
    peek: function () { return last; },
    invalidate: invalidate,
    groupKey: groupKey,
    count: count,
    paintCount: paintCount
  });
}(typeof window === 'undefined' ? null : window));
